const previewTypesByExtension = {
  pdf: "application/pdf",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  webp: "image/webp",
  bmp: "image/bmp",
};

const previewMimeTypes = new Set(Object.values(previewTypesByExtension));

export const getMinutePreviewType = (file) => {
  const extension = file?.name?.match(/\.([^.]+)$/)?.[1]?.toLowerCase();
  if (extension) return previewTypesByExtension[extension] ?? null;

  const mimeType = (file?.type ?? "").split(";")[0].toLowerCase();
  return previewMimeTypes.has(mimeType) ? mimeType : null;
};
